/**
 * 获得页面项目版本号,并放入queryString,以便做日志的区分
 */
(function (win, doc, loc) {
    var util = {
        /**
         * 查询参数转换为Object
         * @param string
         * @returns {{}}
         */
        parseQueryString    : function (string) {
            var parsed = {};
            string = (string !== undefined) ? string : loc.search;
            if (typeof string === "string" && string.length > 0) {
                if (string[0] === '?') {
                    string = string.substring(1);
                }

                string = string.split('&');

                for (var i = 0, length = string.length; i < length; i++) {
                    var element = string[i],
                        eqPos = element.indexOf('='),
                        keyValue, elValue;

                    if (eqPos >= 0) {
                        keyValue = element.substr(0, eqPos);
                        elValue = element.substr(eqPos + 1);
                    }
                    else {
                        keyValue = element;
                        elValue = '';
                    }

                    elValue = decodeURIComponent(elValue);

                    if (parsed[keyValue] === undefined) {
                        parsed[keyValue] = elValue;
                    }
                    else if (parsed[keyValue] instanceof Array) {
                        parsed[keyValue].push(elValue);
                    }
                    else {
                        parsed[keyValue] = [parsed[keyValue], elValue];
                    }
                }
            }

            return parsed;
        },
        /**
         * 对象转换为查询参数
         * @param obj
         * @returns {string}
         */
        stringifyQueryString: function (obj) {
            var string = [];
            if (!!obj && obj.constructor === Object) {
                Object.keys(obj).forEach(function (prop) {
                    if (Array.isArray(obj[prop])) {
                        for (var i = 0, length = obj[prop].length; i < length; i++) {
                            string.push([encodeURIComponent(prop), encodeURIComponent(obj[prop][i])].join('='));
                        }
                    }
                    else {
                        string.push([encodeURIComponent(prop), encodeURIComponent(obj[prop])].join('='));
                    }
                })
            }

            return string.join('&');
        },
        /**
         * 设置url里的查询参数,如果已有,则覆盖
         * @param qs
         * @param kvObject
         * @returns {*|string}
         */
        setQuery : function (qs, kvObject) {
            var kv = this.parseQueryString(qs);
            Object.keys(kvObject).forEach(function (key){
                kv[key] = kvObject[key];
                if (!kvObject[key]) {
                    delete kv[key]
                }
            });
            return this.stringifyQueryString(kv);
        }
    };
    /*
     * 是否是淘宝IPAD
     */
    var isTBiPad = function (){
        var ua = navigator.userAgent;
        return /iPad/.test(ua) && /AliApp\(TB-PD/.test(ua);
    };

    var updateTrackerQuery = function () {

        if(isTBiPad()){//IPAD下history.replaceState有BUG,详见http://h5.m.taobao.com/trip/test-ipad-back.html?spm=0.0.0.0.qoqNg3
            return;
        }
        var $abtest = win._$abtest$_;
        var verNode = doc.querySelector('meta[name="alitrip-project-version"]');
        if(!verNode){return;}
        var projectVersion = verNode.getAttribute('content') || '';
        var _query;

        // 往projectVersion中注入abtest信息
        if ($abtest && $abtest.bucket) {
            projectVersion += $abtest.bucket;
        }

        try {
            _query = util.setQuery(loc.search,{
                "_projVer": projectVersion
            });
            history.replaceState({}, doc.title, "?" + _query + loc.hash);
        } catch (e) {}
    };
    updateTrackerQuery();
})(window, document, location);


/*****************
 ** WEBPACK FOOTER
 ** ./components/wlog/src/alitrip_query.js
 ** module id = 14
 ** module chunks = 0
 **/